import { Mail, MapPin, PhoneCall } from "lucide-react";
import { Link } from "react-router-dom";
import { companyConfig, getSiteContent } from "@/data/siteContent";
import { useLanguage } from "@/context/LanguageContext";

export const Footer = () => {
  const { language } = useLanguage();
  const content = getSiteContent(language);

  return (
    <footer className="bg-slate-950 py-12 text-slate-300 md:py-16" data-testid="website-footer">
      <div className="container mx-auto grid max-w-7xl gap-8 px-4 md:grid-cols-3 md:px-6 lg:px-8">
        <div className="space-y-4" data-testid="footer-company-block">
          <h3 className="text-lg font-bold text-white" data-testid="footer-company-name-ar">
            {companyConfig.nameAr}
          </h3>
          <p className="text-sm text-slate-400" data-testid="footer-company-name-en">
            {companyConfig.nameEn}
          </p>
          <p className="text-sm text-slate-400" data-testid="footer-company-description">
            {language === "ar"
              ? "حلول توريد موثوقة للنظافة والضيافة للقطاعات التجارية في المملكة."
              : "Trusted hygiene and hospitality procurement for commercial sectors across Saudi Arabia."}
          </p>
        </div>

        <div data-testid="footer-quick-links-block">
          <h4 className="mb-4 text-base font-semibold text-white" data-testid="footer-quick-links-heading">
            {content.footer.quickLinks}
          </h4>
          <ul className="space-y-2">
            {content.nav.map((item) => (
              <li key={`footer-link-${item.to}`}>
                <Link
                  to={item.to}
                  className="text-sm text-slate-400 transition-colors duration-300 hover:text-secondary"
                  data-testid={`footer-link-${item.to === "/" ? "home" : item.to.replace("/", "")}`}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div data-testid="footer-contact-info-block">
          <h4 className="mb-4 text-base font-semibold text-white" data-testid="footer-contact-heading">
            {content.footer.contactInfo}
          </h4>
          <div className="space-y-3 text-sm">
            <a
              href={`tel:${companyConfig.phone}`}
              className="flex items-center gap-2 text-slate-300 transition-colors duration-300 hover:text-secondary"
              data-testid="footer-phone-link"
            >
              <PhoneCall className="h-4 w-4" /> <span data-testid="footer-phone-value">{companyConfig.phone}</span>
            </a>
            <a
              href={`mailto:${companyConfig.email}`}
              className="flex items-center gap-2 text-slate-300 transition-colors duration-300 hover:text-secondary"
              data-testid="footer-email-link"
            >
              <Mail className="h-4 w-4" /> <span data-testid="footer-email-value">{companyConfig.email}</span>
            </a>
            <a
              href={companyConfig.mapLink}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 text-slate-300 transition-colors duration-300 hover:text-secondary"
              data-testid="footer-map-link"
            >
              <MapPin className="h-4 w-4" />
              <span data-testid="footer-map-value">{language === "ar" ? "موقعنا على الخريطة" : "Find us on map"}</span>
            </a>
          </div>
        </div>
      </div>
      <div className="container mx-auto mt-8 max-w-7xl border-t border-slate-800 px-4 pt-5 text-xs text-slate-500 md:px-6 lg:px-8">
        <p data-testid="footer-copyright-text">
          © {new Date().getFullYear()} {companyConfig.nameAr} — {content.footer.rights}
        </p>
      </div>
    </footer>
  );
};
